import React from 'react';
import { PieChart, AlertTriangle } from 'lucide-react';
import styles from './StatisticsSection.module.css';

const StatisticsSection = () => {
    return (
        <section className={styles.statisticsSection}>
            <div className={styles.container}>
                <div className={styles.statsWrapper}>
                    <div className={styles.statCard}>
                        <div className={styles.iconWrapper}>
                            <AlertTriangle size={32} />
                        </div>
                        <div className={styles.statContent}>
                            <h2 className={styles.statNumber}>75%</h2>
                            <p className={styles.statDescription}>
                                of people experience Glossophobia - the fear of public speaking
                            </p>
                        </div>
                    </div>

                    <div className={styles.divider} />

                    <div className={styles.statCard}>
                        <div className={styles.iconWrapper}>
                            <PieChart size={32} />
                        </div>
                        <div className={styles.statContent}>
                            <h2 className={styles.statNumber}>Only 8%</h2>
                            <p className={styles.statDescription}>
                                seek professional help despite its impact on their careers
                            </p>
                        </div>
                    </div>
                </div>

                <div className={styles.ctaContainer}>
                    <p className={styles.ctaText}>
                        Imagine standing in front of an audience, your voice trembling, 
                        your thoughts scattered. You know what you want to say, but the 
                        words just won’t come out. Millions face this every day, not because 
                        they lack ideas, but because they lack practice, confidence, 
                        and guidance. TopSpeaks will change that.
                    </p>

                </div>
            </div>  
        </section>
    );
};

export default StatisticsSection;